// The page's Rails authenticity token; null, never empty, when the layout rendered none.
export const csrfToken = (): string | null => {
  const token = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content;
  if (!token) return null;
  return token;
};

// The header Rails verifies on a same-origin request that changes data.
export const csrfHeaders = (): Record<string, string> => {
  const token = csrfToken();
  return token ? { 'X-CSRF-Token': token } : {};
};
